import parse from "html-react-parser"
import styles from "./header.module.scss"

interface Props {
  onBackClick: () => void
}

import chevronLeftBlack from "images/layout/chevron-left-black.svg?raw"

const Header = ({ onBackClick }: Props) => {
  return (
    <header className={styles.cancelling_billing}>
      {onBackClick && (
        <button
          type="submit"
          className="button-tertiary button-outlined button-with-icon only-icon-on-mobile"
          aria-label="Back button"
          onClick={onBackClick}
        >
          <span className="button-icon">
            {parse(chevronLeftBlack)}
          </span>
          <span className="hide-on-xs">Back</span>
        </button>
      )}
    </header>
  )
}

export default Header
